module.exports = "<span class=\"span-button\" (click)=\"buttonClicked.emit()\">\n\t<i class=\"{{iconCssClass ? iconCssClass : 'icon--hidden'}}\"></i>\n\t{{buttonText}}\n</span>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/ui-helper/span-button/span-button.html
// module id = Mm/o
// module chunks = 12